import styled from 'styled-components';
import {
  min_xs,
  min_sm,
  min_md,
  min_lg,
  min_lm,
  min_xl,
  min_fhd,
  max_xs,
  max_sm,
  max_md,
  max_lg,
  max_lm,
  max_xl,
  max_fhd,
} from "../variables";

export const RadioInputs = styled.div`
    width : 100%;
    ${props=> props.align ? `text-align : ${props.align};` : ''}
    .item{
        display:inline-block;
        position:relative;
        @media(${max_md}){
          display:block;
          margin-bottom:55px;
          margin-left : 20px;
          font-size: 16px;
          line-height: 20px;
          :last-child{
            margin-bottom:0;
          }
        }
        &__label{
          line-height : 1;
            :hover{
              cursor:pointer;
            }
            &__span{
              width : max-content;
              position:relative;
              max-width : calc(100% - 60px);
              display:inline-block;
              vertical-align:middle;
              @media(${min_lg}){
                font-size: 18px;
                line-height: 34px;
              }
            }
          }

        &__radio{    
            input{
                display:none;
            }
            .checked{
                display:none;
            }
            input:checked ~ .checked{
                display:block;
            }
            input:checked ~ .unchecked{                           
                display:none;
            }
            
            display:inline-block;
            width : 22px;
            vertical-align:middle;
            margin-right : 10px;
            img{
                width : 100%;
                vertical-align: middle;
            }
        }

        &__tooltip{
              display: inline-block;
              position: relative;
              vertical-align: middle;
              margin-left : 10px;
              line-height : 1;
              img{
                width : 17px;
                vertical-align:middle;
              }
            .tooltip_on{
              display: none;
            }
          }
      
          &__tooltiptext{
            visibility: hidden;
            width: 135px;
            box-sizing: border-box;
            background-color: #555;
            color: #fff;
            text-align: center;
            border-radius: 6px;
            padding: 5px 0;
            position: absolute;
            z-index: 1;
            bottom: calc(100% + 12px);
            left: -34px;
            opacity: 0;
            transform:translateX(-50%);
            transition: opacity 0.3s;
            font-size: 12px;
            line-height: 1.2;
            padding: 10px;
            text-align: left;
            white-space: normal;
          }
          &__tooltiptext::after {
            content: "";
            position: absolute;
            top: 100%;
            left: 82%;
            margin-left: -5px;
            border-width: 5px;
            border-style: solid;
            border-color: #555 transparent transparent transparent;

          }
          &__tooltip:hover{
            .tooltip_on{
              display: unset;
            }
            .tooltip_off{
              display:none;
            }
            .item__tooltiptext{
                visibility: visible;
                opacity: 1;
            }
          }
    }
    .half{
      @media(${min_md}){
        width : calc((100% - 40px)/2);
        margin-right : 40px;
        :nth-child(2n){
            margin-right : 0;
        }
      }
  }
  .third{
    @media(${min_md}){
      width : calc((100% - 40px)/3);
      margin-right : 20px;
      :nth-child(3n){
          margin-right : 0;
      }
    }
  }
  .third-md{
    @media(${max_md}){
      display:inline-block;
      width : calc((100% - 40px)/3);
      margin-right : 20px;
      :nth-child(3n){
          margin-right : 0;
      }
    }
  }
  .no-bottom-md{
    margin-bottom : 10px;
  }
  .yellow{
    color: #F7924E;
    .unchecked{
      filter: invert(50%) sepia(80%) saturate(1000%) hue-rotate(5deg);
    }
  }
`